<template>
    <div>
        <p v-if="getChangedStore1 && (ltype=='1')">{{readFromStore()}}</p>
        <p v-if="getChangedStore2 && (ltype=='2')">{{readFromStore()}}</p>
        <p v-if="getRefresh1 && (ltype=='1')">{{refreshData()}}</p>
        <p v-if="getRefresh2 && (ltype=='2')">{{refreshData()}}</p>
        
        <div>
            <v-toolbar dense @click="$store.commit('changeCollapse',0)">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Assignment ({{mycontent.content.length}} chars)</v-toolbar-title>
            </v-toolbar>
            <div v-if="getCollapses.a">
                <v-flex xs12 >
                    <quill-editor v-model="mycontent.content" :options="getEditorOption()">
                    </quill-editor>
                </v-flex>
                <v-flex xs12 justify-end>
                    <v-btn @click="showHtmlC">Show HTML</v-btn>
                    <v-btn v-if="showedHtmlC" @click="updateC">Update</v-btn>
                </v-flex>
                <v-textarea v-if="showedHtmlC" v-model="HtmlContent">
                </v-textarea>
            </div>

            <v-toolbar dense @click="$store.commit('changeCollapse',1)">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Lines to reorder ({{mycontent.code.length}} chars)</v-toolbar-title>
            </v-toolbar>
            <div v-if="getCollapses.b">

                <v-flex xs12>
                    <quill-editor v-model='mycontent.code' :options="getEditorOption2()">
                    </quill-editor>
                </v-flex>
                <v-flex xs12 justify-end>
                    <v-btn @click="showHtmlCD">Show HTML</v-btn>
                    <v-btn v-if="showedHtmlCD" @click="updateCD">Update</v-btn>
                </v-flex>
                <v-textarea v-if="showedHtmlCD" v-model=HtmlCode>
                </v-textarea>

                
                <v-card>
                    <v-card-title>Data to reorder: <v-btn @click="getLines()">Analyse</v-btn></v-card-title>
                    <v-card-text v-if="lines.length > 0">
                        <div v-for="(fd,index) in lines" :key="index">
                            <v-chip>{{fd}}</v-chip>
                        </div>
                    </v-card-text>
                </v-card>
                
            </div>
            
            <v-toolbar dense @click="$store.commit('changeCollapse',2)">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Help</v-toolbar-title>
            </v-toolbar>
            <div v-if="getCollapses.c">
                <v-flex xs12>
                    <quill-editor v-model="mycontent.help" :options="getEditorOption()">
                    </quill-editor>
                </v-flex>
                <v-flex xs12 justify-end>
                    <v-btn @click="showHtmlH">Show HTML</v-btn>
                    <v-btn v-if="showedHtmlH" @click="updateH">Update</v-btn>
                </v-flex>
                <v-textarea v-if="showedHtmlH" v-model=HtmlHelp>
                </v-textarea>
            
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import * as misc from '../../assets/misc.js'
//import 'highlight.js/styles/routeros.css'
//import hljs from 'highlight.js'

export default {
    data() {
        return {
                showedHtmlC : false,
                showedHtmlCD : false,
                showedHtmlH : false,
                mycontent:  {
                    content: 'loading...',
                    code: 'loading...',
                    codes: 'loading',
                    help: 'loading...'
                },
                HtmlContent: '',
                HtmlCode: '',
                HtmlCodes: '',                
                HtmlHelp: '',
                lines: []            
              }
    },
    props: ['ltype'],
    computed: 
            mapGetters([
                            'getLanguagePrimary',   
                            'getLanguageSecondary',
                            'getLanguagePrimaryTmp',   
                            'getLanguageSecondaryTmp',
                            'getRefresh1',
                            'getRefresh2',
                            'getChangedStore1',
                            'getChangedStore2',
                            'getContent567',
                            'getCollapses',
                            'getFakes'
                        ])
    ,
    components: {
        quillEditor
    },
    methods: {
        showHtmlC() {
            this.showedHtmlC = !this.showedHtmlC
            this.HtmlContent = this.mycontent.content
        },
        showHtmlCD() {
            this.showedHtmlCD = !this.showedHtmlCD
            this.HtmlCode = this.mycontent.code
            this.HtmlCodes = this.mycontent.codes
        },
        showHtmlH() {
            this.showedHtmlH = !this.showedHtmlH
            this.HtmlHelp = this.mycontent.help
        },
        updateC() {
            this.mycontent.content = this.HtmlContent
        },
        updateCD() {
            this.mycontent.code = this.HtmlCode
            this.mycontent.codes = this.HtmlCodes
        },
        updateH() {
            this.mycontent.help = this.HtmlHelp
        },
        getLines() {
            var result = misc.hardReplace(this.mycontent.code, ' class="ql-syntax" spellcheck="false"', '')
            result = misc.hardReplace(result, '\n', '</pre><pre>')
            result = misc.hardReplace(result, '<pre></pre>','')
            result = misc.hardReplace(result, '<p></p>','')
            result = misc.hardReplace(result, '<p><br></p>','')
            var codes = []
            while (result.indexOf('<pre>')> -1 || result.indexOf('<p>')> -1) {
                let _ps = result.indexOf('<p>')
                let _pres = result.indexOf('<pre>')
                if (((_ps < _pres) && (_ps > -1)) || (_pres == -1)) {
                    let _pe = result.indexOf('</p>',_ps)
                    codes.push("<p>" + result.substring(_ps + 3, _pe) + "</p>")    
                    result = result.substring(0,_ps) + result.substring(_pe+4)
                    continue
                }
                if (((_pres < _ps) && (_pres > -1)) || (_ps == -1)) {
                    let _pree = result.indexOf('</pre>',_pres)
                    codes.push("<pre>"+result.substring(_pres + 5, _pree)+"</pre>")    
                    result = result.substring(0,_pres) + result.substring(_pree+1) // \n  
                }
            }
            this.lines = codes
        },

        /************************************************************ */
        saveActualContent(mylang) {  
            this.getLines()
            this.mycontent.codes = this.lines 

            var data = {
                lang_id : mylang.id,
                content: this.mycontent
            }
            this.$store.commit('setContent567', data)            
        },

        refreshData() {
           // var lang = null
            if (this.ltype =='1') {
                this.$store.commit('setRefresh1',false)
                if (this.getLanguagePrimaryTmp) {
                    this.saveActualContent(this.getLanguagePrimaryTmp)
                }
                this.$store.commit('setChangedStore1',true)
            } else {
                this.$store.commit('setRefresh2',false)
                if (this.getLanguageSecondaryTmp)
                    this.saveActualContent(this.getLanguageSecondaryTmp)
                this.$store.commit('setChangedStore2',true)            
            }            
        },
        getContent567fromStore(lang_id) {
            return this.getContent567(lang_id)
        },

        readFromStore() {
            var con = -1
            if (this.ltype == 1) {
                this.$store.commit('setChangedStore1',false)
                con = this.getContent567fromStore(this.getLanguagePrimary.id)
                this.mycontent = con
            }
            if (this.ltype == 2) {                
                this.$store.commit('setChangedStore2',false)
                con = this.getContent567fromStore(this.getLanguageSecondary.id)
                this.mycontent = con
            }
        },
        getEditorOption() {
          return {
                modules: {
                    'toolbar': [
                    [{ 'header': '1' }, { 'header': '2' }],
                    [ 'bold', 'italic', 'underline', 'strike' ],
                    ['code-block','blockquote',  { 'color': [] }, { 'background': [] }],
                    [{ 'script': 'super' }, { 'script': 'sub' }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'align': [] }],
                    [ 'link', 'image', 'formula' ],
                    [ 'clean' ]
                    ],
     /*               syntax: {
                        highlight: text => hljs.highlightAuto(text).value
                    },
       */             imageDrop: true,
                    imageResize: true
                },
                theme: 'snow'
            }
        },
        getEditorOption2() {
          return {
                modules: {
                    'toolbar': [
                    [ 'bold', 'italic', 'underline', 'strike' ],
                    ['code-block', { 'color': [] }, { 'background': [] }],
                    [{ 'script': 'super' }, { 'script': 'sub' }],
                    [ 'image', 'formula' ],
                    [ 'clean' ]
                    ],
                    imageDrop: true,
                    imageResize: true
                },
                theme: 'snow'
            }
        }
    } 

}
</script>


<style>

</style>


